export const editMutations = <const>{
	PUJCOVNA_VOZIDEL_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'PUJCOVNA_VOZIDEL_NAKLADOVE_STREDISKO_SELECT_MAPPER',
};
